export default __webpack_public_path__ + "static/cta-mockup-light-a728193eec5655c320c05eb9c8f6773e.png";